import { OptionsItemLayoutData, OptionsItemLiveData, OptionsItemLocData, OptionsItemThemeData, OptionsCategoryCompoundData, OptionsItemLayoutDefinitionData } from "../../../types/types";
import { AppSettings } from "../../managers/AppSettings";
import { SettingsItem } from "./SettingsItem";
import { OptionsToggleItem } from "./OptionsToggleItem";
import { LoaderFileKeys } from "../../constant/AppConstants";
import { OptionsSliderItem } from "./OptionsSliderItem";
import { IInteractive } from "../../../interfaces/IInteractive";
import { OptionsSelectorItem } from "./OptionsSelectorItem";
import { ScrollPaneTitledListContent } from "../dealcomplete/ScrollPaneTitledListContent";
import { OptionsLeafPopup } from "./OptionsLeafPopup";
import { OptionsItemBase } from "./OptionsItemBase";
import { OptionsDataManager } from "../../managers/OptionsDataManager";
import { LayoutDataManager, OptionsItemKeys } from "../../managers/LayoutDataManager";
import { AppObjectPool } from "../../pooling/AppObjectPool";
import { OptionsContentScroll } from "./OptionsContentScroll";
import { AppAudioPlayer, SoundEffectKeys } from "../../../audio/AppAudioPlayer";
import { GTMTracking } from "../../managers/GTMTracking";
import { OptionsItemType } from "./OptionsItem";
import { OptionsButtonItem } from "./OptionsButtonItem";
import { AppLocalization } from "../../localization/AppLocalization";
import { VariationId } from "../TableScreen";
import GameScene from "../../../scenes/GameScene";
import { PopupBinary, PopupBinaryChoiceType } from "../../popup/PopupBinary";
import { StatisticsDataManager } from "../../managers/StatisticsDataManager";


/**
 * 
 * 
 * @alike @see DealCompleteResultsContent
 * (except Results Content has custom item types per subcontent section, 
 * and Options parses json for typeId to determine individual item type)
 */
export class OptionsCategoryContent
    extends ScrollPaneTitledListContent {
    protected categoryData: OptionsCategoryCompoundData;
    //ref
    protected leafItemPopup: OptionsLeafPopup;
    /**
     * Last item clicked that opened leaf popup (usually a SelectorItem)
     * Used when leaf popup items (if has items) selected item changes
     */
    protected lastClickedItem: OptionsItemBase;
    private parent: OptionsContentScroll;
    private delimiterLineAlpha: number;


    /**
     * Use data to create items (once and for all) in @see Build
     * 
     * @param categoryData Set via @see Init, only used to create items by id 
     *                     (not fill them with data)
     */
    public override Init(
        parent?: OptionsContentScroll,
        categoryData?: OptionsCategoryCompoundData,
    ): void {
        // > items
        super.Init();

        this.delimiterLineAlpha = LayoutDataManager.GetSharedData().general.screen.item.delimiterLine.alpha;

        this.parent = parent;
        this.categoryData = categoryData;
        this.nodeTheme = this.categoryData.theme; // for base icon
        // this.name = "OptionsCategoryContent";
    }

    public Build(): void {
        // > build title
        super.Build();

        // sort vertically by layoutDatas (this model is for client to change order as they wish)
        this.categoryData.layout.items.forEach((itemLayoutData: OptionsItemLayoutData, i: number) => {
            const item: OptionsItemBase = this.GetFromPoolOrNew(itemLayoutData);
            this.items.push(item);
            this.add(item);
        });

        this.add(this.nsContentBg);

        this.UpdateFromLocalizationChange();
    }

    public SetData(
        categoryData: OptionsCategoryCompoundData
    ): void {
        // console.log("SetData");

        this.categoryData = categoryData;
        this.nodeTheme = categoryData.theme;

        while (this.items.length) {
            const removedItem: OptionsItemBase = this.items.pop();
            removedItem.UnregisterListeners();
            // this.remove(removedItem);
            const itemPoolGroupKey: string = this.parent.catItemsData.poolGroupKeysByItemType[removedItem.GetType()];
            // console.log("pre-drop:",AppObjectPool.GetObjectsCount(itemPoolGroupKey));
            AppObjectPool.DropObject(removedItem, itemPoolGroupKey);
            // console.log("post-drop:",AppObjectPool.GetObjectsCount(itemPoolGroupKey));
        }

        this.categoryData.layout.items.forEach((itemLayoutData: OptionsItemLayoutData, i: number) => {
            const item: OptionsItemBase = this.GetFromPoolOrNew(itemLayoutData);
            this.items.push(item);
            this.add(item);
        });

        this.UpdateFromLocalizationChange();
    }

    public GetItemById(itemId: string): OptionsItemBase | null {
        for (let i = 0; i < this.items.length; i++) {
            const item: OptionsItemBase = this.items[i];
            if (item.GetId() == itemId) {
                return item;
            }
        }
        return null;
    }

    private GetFromPoolOrNew(
        itemLayoutData: OptionsItemLayoutData,
    ): OptionsItemBase {
        const itemLayoutDef: OptionsItemLayoutDefinitionData = LayoutDataManager.GetItemDefinitionData(itemLayoutData.id);
        // eg 'OptionsItem0' for OptionsItemType.TOGGLE eg 'pool of' OptionsToggleItem-s
        const groupKey: string = this.parent.catItemsData.poolGroupKeysByItemType[itemLayoutDef.itemType];
        // console.log(itemLayoutData, itemLayoutDef, groupKey, AppObjectPool.GetObjectsCount(groupKey));
        let item: OptionsItemBase = AppObjectPool.PickObject(groupKey);
        // console.log("post-pick:",AppObjectPool.GetObjectsCount(groupKey));
        if (item == null) {
            // const itemId: string = itemLayoutData.id;
            // console.log(i, itemLiveData, OptionsItemType[itemLayoutData.itemType]);
            // const itemThemeData: OptionsItemThemeData = this.categoryData.theme.itemsById[itemId];
            // const itemLocData: OptionsItemLocData = this.categoryData.loc.itemsById[itemId];
            // const itemLiveData: OptionsItemLiveData = this.categoryData.live.itemsById[itemId];
            switch (itemLayoutDef.itemType) {
                case OptionsItemType.TOGGLE:
                    const toggleItem = new OptionsToggleItem(this.scene);
                    toggleItem.Init(
                        // i,
                        this.parent.catItemsData.bgTextureStates,
                        this.parent.catItemsData.labelTextStates,
                        this.parent.catItemsData.bgTextureToggleStates,
                        this.parent.catItemsData.labelTextToggleStates,
                        this.OnItemToggleChange.bind(this),
                        this.OnItemHelpClick.bind(this),
                        this.delimiterLineAlpha,
                    );
                    item = toggleItem;
                    break;

                case OptionsItemType.SLIDER:
                    const sliderItem = new OptionsSliderItem(this.scene);
                    sliderItem.Init(
                        // i,
                        this.parent.catItemsData.bgTextureStates,
                        this.parent.catItemsData.labelTextStates,
                        this.parent.catItemsData.valueTextStates,
                        this.OnItemSliderChange.bind(this),
                        this.delimiterLineAlpha,
                    );
                    item = sliderItem;
                    break;

                case OptionsItemType.SELECTOR:
                    const selectorItem = new OptionsSelectorItem(this.scene);
                    selectorItem.Init(
                        this.parent.catItemsData.bgTextureStates,
                        this.parent.catItemsData.labelTextStates,
                        this.parent.catItemsData.selectorLabelTextStates,
                        this.OnItemSelectorClick.bind(this),
                        this.OnItemHelpClick.bind(this),
                        this.delimiterLineAlpha,
                    );
                    item = selectorItem;
                    break;
                case OptionsItemType.BUTTON:
                    const buttonItem = new OptionsButtonItem(this.scene);
                    buttonItem.Init(
                        this.parent.catItemsData.bgTextureStates,
                        this.parent.catItemsData.labelTextStates,
                        this.OnItemButtonClick.bind(this),
                        this.delimiterLineAlpha,
                    );
                    item = buttonItem;
                    break;

                default:
                    console.log("OptionsCategoryContent::Undefined item type: " + itemLayoutDef.itemType + "!")
            }
        }
        item.RegisterListeners();
        return item;
    }

    public UpdateFromLocalizationChange(): void {
        // category title
        const sTitle: string = this.categoryData.loc.title;
        this.btnTitle.SetLabel(sTitle);

        for (let i: number = 0; i < this.categoryData.layout.items.length; i++) {
            const item: OptionsItemBase = this.items[i];
            const itemLayoutData: OptionsItemLayoutData = this.categoryData.layout.items[i];
            const itemLocData: OptionsItemLocData = this.categoryData.loc.itemsById[itemLayoutData.id];
            const itemThemeData: OptionsItemThemeData = this.categoryData.theme.itemsById[itemLayoutData.id];
            // const itemLiveData: OptionsItemLiveData = this.categoryData.live.itemsById[itemLayoutData.id];
            const itemLiveData: OptionsItemLiveData = OptionsDataManager.GetItemDataByItemId(itemLayoutData.id, this.parent.curVariationId);
            const itemLayoutDef: OptionsItemLayoutDefinitionData = LayoutDataManager.GetItemDefinitionData(itemLayoutData.id);
            // console.log(itemLocData);

            // handle locked / interactive override?
            // console.log(itemThemeData.locked)
            let isItemInteractive: boolean = !(itemThemeData?.locked == true);
            (item as unknown as IInteractive).SetInteractive?.(isItemInteractive, true);
            const hasDelimiterLine = this.categoryData.layout.items.length != i + 1;

            switch (itemLayoutDef.itemType) {
                case OptionsItemType.TOGGLE:
                    (item as OptionsToggleItem).SetData(
                        itemLayoutData,    // itemLayoutData?: OptionsItemLayoutData
                        itemThemeData,     // itemThemeData?: OptionsItemThemeData
                        itemLocData,       // itemLocData?: OptionsItemLocData
                        itemLiveData,      // itemLiveData?: OptionsItemLiveData
                        hasDelimiterLine,
                    );
                    break;

                case OptionsItemType.SLIDER:
                    (item as OptionsSliderItem).SetData(
                        itemLayoutData,    // itemLayoutData?: OptionsItemLayoutData
                        itemThemeData,     // itemThemeData?: OptionsItemThemeData
                        itemLocData,       // itemLocData?: OptionsItemLocData
                        itemLiveData,      // itemLiveData?: OptionsItemLiveData
                        hasDelimiterLine,
                    );
                    break;

                case OptionsItemType.SELECTOR:
                    (item as OptionsSelectorItem).SetData(
                        itemLayoutData,    // itemLayoutData?: OptionsItemLayoutData
                        itemThemeData,     // itemThemeData?: OptionsItemThemeData
                        itemLocData,       // itemLocData?: OptionsItemLocData
                        itemLiveData,      // itemLiveData?: OptionsItemLiveData
                        hasDelimiterLine,
                    );
                    break;

                case OptionsItemType.BUTTON:
                    (item as OptionsSelectorItem).SetData(
                        itemLayoutData,    // itemLayoutData?: OptionsItemLayoutData
                        itemThemeData,     // itemThemeData?: OptionsItemThemeData
                        itemLocData,       // itemLocData?: OptionsItemLocData
                        itemLiveData,      // itemLiveData?: OptionsItemLiveData
                        hasDelimiterLine,
                    );
                    break;

                default:
                    console.log("OptionsCategoryContent::UpdateFromLocalizationChange; Undefined item type: " + itemLayoutDef.itemType + "!")
            }

            // update size of item (this will update position of btnHElp)
            // (item as OptionsToggleItem).UpdateFromLocalizationChange();
        }
    }

    public SetLeafItemPopup(leafItemPopup: OptionsLeafPopup): void {
        this.leafItemPopup = leafItemPopup;
    }

    protected OnItemToggleChange(
        item: OptionsToggleItem,
        newValue: boolean,
    ): void {
        // console.log(this.name, item.name, newValue);

        // GTMTracking
        GTMTracking.PLDTrackingSettingChanged(item.GetId(), newValue.toString());

        // ui click sound
        AppAudioPlayer.PlaySfx(SoundEffectKeys.click4);

        // NEW: instantly react by saving to localStorage and updating views
        // resolve data change and update views (eg 'replace background tile')
        OptionsDataManager.ResolveLiveDataChange(this.parent.curVariationId, true);
    }

    protected OnItemSliderChange(
        item: OptionsToggleItem,
        newValue: boolean,
    ): void {
        // console.log("slider item value changed");
        // console.log(this.name, item.name, newValue);

        // GTMTracking
        GTMTracking.PLDTrackingSettingChanged(item.GetId(), newValue.toString());

        // ui click sound
        AppAudioPlayer.PlaySfx(SoundEffectKeys.click4);

        // NEW: instantly react by saving to localStorage and updating views
        // resolve data change and update views (eg 'replace background tile')
        OptionsDataManager.ResolveLiveDataChange(this.parent.curVariationId, true);
    }

    protected OnItemSelectorClick(
        // itemIndex: number,
        item: OptionsSelectorItem,
        itemLayoutData: OptionsItemLayoutData,
        itemThemeData: OptionsItemThemeData,
        itemLocData: OptionsItemLocData,
        itemLiveData: OptionsItemLiveData
    ): void {
        // console.log("OnItemSelectorClick; itemIndex:", itemIndex);

        // ui click sound
        AppAudioPlayer.PlaySfx(SoundEffectKeys.click4);

        // remember index of this item (last clicked selector that opened the popup)
        // this.lastClickedItemIndex = itemIndex;
        this.lastClickedItem = item;

        // SetData triggers SetSize on LeafPopup
        this.leafItemPopup.SetCallback(this.OnLeafPopupContentItemSelected.bind(this));
        this.leafItemPopup.SetData(
            itemLayoutData,
            itemThemeData,
            itemLocData,
            itemLiveData,
        );
        // shows both the LeafPopup and it's content 
        // @see OptionsLeaftPopup::OnShowStart
        this.leafItemPopup.Show();
    }

    /**
     * 
     * @param itemId Item id from Layout id
     * example: "resetOptionsBelote" | "resetStatsBelote"
     */
    protected OnItemButtonClick(itemId: string): void {
        // console.log("button item clicked", itemId);

        // ui click sound
        AppAudioPlayer.PlaySfx(SoundEffectKeys.click4);

        // atm button click always means binary popup opening
        const binaryPopup: PopupBinary = (this.scene as GameScene).optionsScreen.binaryPopup;
        let popupTitle: string;
        let primaryButtonLabel: string;
        let secondaryButtonLabel: string;
        let itemLocData: OptionsItemLocData = AppLocalization.GetSharedData().options.itemsById[itemId];
        
        popupTitle = itemLocData.popupTitle;
        primaryButtonLabel = itemLocData.choices[0].itemLabel as string;
        secondaryButtonLabel = itemLocData.choices[1].itemLabel as string;

        binaryPopup.SetTitle(popupTitle);
        binaryPopup.SetPrimaryButtonLabel(primaryButtonLabel);
        binaryPopup.SetSecondaryButtonLabel(secondaryButtonLabel);
        binaryPopup.UpdateView();
        binaryPopup.SetData({
            taskType: null,
            onComplete: (taskType, taskData)=>{
                this.OnItemButtonBinaryPopupClose(taskData.choiceType, itemId);
            },
        });
        // unregister events from optionsContentScroll (prevents bugging content scroll)
        this.parent.UnregisterListeners();
        binaryPopup.Show();
        // 
        // root.inputData.onComplete(root.inputData.taskType, {choiceType:choiceType});
    }

    public OnItemButtonBinaryPopupClose(choiceType: PopupBinaryChoiceType, itemId: string): void {
        // register back events for optionsContentScroll (prevents bugging content scroll)
        this.parent.RegisterListeners();

        // if reset was pressed
        if (choiceType === PopupBinaryChoiceType.PRIMARY) {
            switch(itemId) {
                case OptionsItemKeys.resetOptionsBelote:
                    OptionsDataManager.SetDefaults(VariationId.BELOTE);
                    break;
                case OptionsItemKeys.resetOptionsCoinche:
                    OptionsDataManager.SetDefaults(VariationId.COINCHE);
                    break;
                case OptionsItemKeys.resetOptionsContree:
                    OptionsDataManager.SetDefaults(VariationId.CONTREE);
                    break;
                case OptionsItemKeys.resetStatsBelote:
                    StatisticsDataManager.SetDefaults(VariationId.BELOTE, true);
                    break;
                case OptionsItemKeys.resetStatsCoinche:
                    StatisticsDataManager.SetDefaults(VariationId.COINCHE, true);
                    break;
                case OptionsItemKeys.resetStatsContree:
                    StatisticsDataManager.SetDefaults(VariationId.CONTREE, true);
                    break;
            }
        }
    }

    /**
     * Triggers from LeafPopup when item inside its content has been selected.
     * Only for leaf popups with content that has items (eg TextContent has no items, only text).
     */
    protected OnLeafPopupContentItemSelected(selectedItemIndex: number): void {
        // console.log("OnLeafPopupContentItemSelected");

        // GTMTracking
        GTMTracking.PLDTrackingSettingChanged(this.lastClickedItem.GetId(), selectedItemIndex.toString());

        // ui click sound
        AppAudioPlayer.PlaySfx(SoundEffectKeys.click4);

        // update from locally stored data (same reference, possibly different value)
        // NOTE: lastClickedItemIndex is usually last clicked OptionsSelectorItem index
        //       (index matches it's position in this.items)
        this.lastClickedItem.UpdateViewFromDataChange();

        // NEW: instantly react by saving to localStorage and updating views
        // resolve data change and update views (eg 'replace background tile')
        OptionsDataManager.ResolveLiveDataChange(this.parent.curVariationId, true);
    }

    protected OnItemHelpClick(
        itemLayoutData: OptionsItemLayoutData,
        itemThemeData: OptionsItemThemeData,
        itemLocData: OptionsItemLocData,
        itemLiveData: OptionsItemLiveData
    ): void {
        // console.log("help btn click");

        // ui click sound
        AppAudioPlayer.PlaySfx(SoundEffectKeys.click4);

        // NOTE: triggers SetSize
        this.leafItemPopup.SetData(
            itemLayoutData,
            itemThemeData,
            itemLocData,
            itemLiveData,
            true // setHelpText? (prioritizes using text node as data node)
        );
        this.leafItemPopup.Show();
    }

    public override SetWidth(width: number): void {
        // console.log("SetWidth");

        super.SetWidth(width);

        this.RedrawBorder();
    }
}